import { render, staticRenderFns } from "./addCargo.vue?vue&type=template&id=1b87343e&"
import script from "./addCargo.vue?vue&type=script&lang=js&"
export * from "./addCargo.vue?vue&type=script&lang=js&"
import style0 from "./addCargo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b87343e')) {
      api.createRecord('1b87343e', component.options)
    } else {
      api.reload('1b87343e', component.options)
    }
    module.hot.accept("./addCargo.vue?vue&type=template&id=1b87343e&", function () {
      api.rerender('1b87343e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/OMS/components/Warehousing/addCargo.vue"
export default component.exports